// extracted by mini-css-extract-plugin
export default {"root":"_3zbJs","scrollable":"_1r8CJ","size-small":"_2AoBk","sizeSmall":"_2AoBk","size-medium":"_2rBLW","sizeMedium":"_2rBLW","tag-item":"_2Qu3Z","tagItem":"_2Qu3Z"};